<template>
    <div class="index-tariff">
        <Container width="landing" class="index-tariff__container">
            <div class="index-tariff__wrapper">
                <div class="index-tariff__block">
                    <h2 class="index-tariff__title">
                        <span class="_mobile">Тарифы</span>
                        <span class="_desktop">Фиксированные тарифы</span>
                    </h2>

                    <IndexTariffTabs v-model="subscriptionIndex"
                                     class="index-tariff__tabs"
                                     :tabs="tariff.subscriptionTime"
                    />

                    <TariffCarousel :tariffs="tariff.tariffsList" :subscription-index="subscriptionIndex" />
                </div>

                <slot name="banner" />
            </div>
        </Container>
    </div>
</template>

<script setup lang="ts">
    import type { TariffData } from '~/src/shared/components/pages/index/mock/indexTariff'
    import Container from '~/src/shared/components/common/Container/Container.vue'
    import IndexTariffTabs from '~/src/shared/components/pages/index/IndexTariff/IndexTariffTabs.vue'
    import TariffCarousel from '~/src/widgets/tariff-carousel/TariffCarousel.vue'

    defineProps<{
        tariff: TariffData
    }>()

    const subscriptionIndex = ref(0)
</script>

<style scoped lang="scss">
.index-tariff {
        &__wrapper {
            width: calc(100% + var(--container-offset) * 2);
            margin-left: calc(-1 * var(--container-offset));
            padding: 80px var(--container-offset);
            border-radius: 72px;
            background-color: var(--white);

            @include respond-to(tablet) {
                padding: 80px var(--container-offset) 40px;
            }

            @include respond-to(mobile) {
                overflow: hidden;
                padding: 24px var(--container-offset) 20px;
                border-radius: 32px;
            }
        }

        &__block {
            margin-bottom: 60px;

            @include respond-to(mobile) {
                margin-bottom: 40px;
            }
        }

        &__tabs {
            margin-top: 16px;

            @include respond-to(mobile) {
                margin-top: 0;
            }
        }

        &__title {
            @include mulish40b;

            ._mobile {
                display: none;

                @include respond-to(mobile) {
                    display: block;
                }
            }

            ._desktop {
                @include respond-to(mobile) {
                    display: none;
                }
            }
        }
    }
</style>
